import {
  toWSDateString,
  WSButton,
  WSFlexBox,
  WSIcon,
  WSText
} from "@wingspanhq/fe-component-library";
import React, { useMemo } from "react";
import {
  ADD_TO_CALENDAR_LINK,
  getCurrentIRSQuarter,
  getInternalProcessingDeadline
} from "../../../shared/utils/taxes";
import { openInNewTab } from "../../../utils/openInNewTab";
import { useModalTaxesQuarterInfo } from "../modals/TaxesModalQuarterInfo";

export const NextPaymentInfo: React.FC = () => {
  const modalTaxInfo = useModalTaxesQuarterInfo();

  const text = useMemo(() => {
    const quarter = getCurrentIRSQuarter();
    const internalProcessingDeadline = getInternalProcessingDeadline(
      quarter.dueDate,
      "MMM DD, YYYY"
    );
    const internalDeadlineFromNow = internalProcessingDeadline.fromNow(true);
    const isFuture = internalProcessingDeadline.isAfter(new Date(), "day");
    const isToday = internalProcessingDeadline.isSame(new Date(), "day");

    const diff = isFuture
      ? ` due in ${internalDeadlineFromNow} `
      : isToday
      ? " today "
      : ` was due ${internalDeadlineFromNow} ago`;

    return `Next quarterly payment${diff} (${toWSDateString(
      internalProcessingDeadline.toDate(),
      "monthDate"
    )}).`;
  }, []);

  return (
    <WSFlexBox.CenterY gap="S">
      <WSText.ParagraphXs>{text}</WSText.ParagraphXs>

      <WSIcon
        name="info-circle-fill"
        size="S"
        color="gray500"
        onClick={() => modalTaxInfo.open()}
      />

      <WSButton.Link
        size="S"
        onClick={() => {
          openInNewTab(ADD_TO_CALENDAR_LINK);
        }}
      >
        Subscribe to Tax Calendar
      </WSButton.Link>
    </WSFlexBox.CenterY>
  );
};
